import { createSlice } from "utils/@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import set from "lodash/set";
import { FormError } from "app/containers/types";
import { ContainerState } from "../types";

// The initial state of the GithubRepoForm container
export const initialState: ContainerState = {
  email: {
    value: "",
  },
  password: {
    value: "",
  },
  loading: false,
  error: null,
};

const formSlice = createSlice({
  name: "loginState",
  initialState,
  reducers: {
    setFormValues: (state, action: PayloadAction<{ key: string; value: string }>) => {
      const { key, value } = action.payload;
      set(state, `${key}.value`, value);
      set(state, `${key}.error`, "");
    },
    setFormErrors(
      state,
      action: PayloadAction<Array<FormError>>
    ) {
      action.payload.forEach((error) => {
        set(state, `${error.name}.error`, error.error);
      });
    },
    login(state, action: PayloadAction<{ callback?: () => void }>){
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state) {
      state.email = {
        value: "",
      };
      state.password = {
        value: "",
      };
      state.loading = false;
      state.error = null;
    },
    loginError(state) {
      state.loading = false;
    }
  },
});

export const { actions, reducer: loginReducer, name: loginSlice } = formSlice;
